import { HierarchyContextProps, IHierarchyActionUpdateTlfItemIndex } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Updates the cached TLF item index and latest ToC minor version.
 *
 * @param state - The current hierarchy context state.
 * @param action - The update-TLF-item-index action to apply.
 * @returns The updated hierarchy context state or the unchanged state when no hierarchy is loaded.
 */
export const hcr_updateTlfItemIndex = (
  state: HierarchyContextProps,
  action: IHierarchyActionUpdateTlfItemIndex,
): HierarchyContextProps => {
  if (!state.hierarchy) return state;

  return hcr_updateChangedFlag(
    {
      ...state,
      hierarchy: {
        ...state.hierarchy,
        tocMinorVersion: action.tocMinorVersion,
      },
      tlfItemIndex: action.tlfItemIndex,
    },
    action,
  );
};
